
















































import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class Ratings extends Vue {
    @Prop(String) readonly title: string | undefined
    @Prop(String) readonly text: string | undefined
    @Prop(String) readonly primaryText: string | undefined
    @Prop(String) readonly primaryEvent: string | undefined
    @Prop(String) readonly secondaryText: string | undefined
    @Prop(String) readonly closeEvent: string | undefined
    @Prop(Boolean) readonly show: boolean | undefined
}
